import {Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {AngularFireDatabase, AngularFireList} from 'angularfire2/database';
import {ChatService} from 'src/app/business/chat/service/chat.service';
import {AuthService} from 'src/app/business/chat/service/auth.service';
import * as models from 'src/app/business/chat/interface';
import {concatMap, exhaustMap, map, mapTo, mergeMap, take, takeLast, takeUntil, tap} from 'rxjs/operators';
import {combineLatest, forkJoin, Subject, Subscription} from 'rxjs';
import * as _ from 'lodash';
import {ActivatedRoute} from '@angular/router';

import {BusinessCodeService, BusinessInfoService, BusinessResolver} from '../../../../services';
import {AccountInfoService} from '../../../../services/business/account-info/account-info.service';
import {OptionDto} from '../../ common/option.dto';
import {mapRoom, Room} from 'src/app/business/chat/interface/Room';
import {GlnInfoDto} from '../../interface/gln-info.dto';


declare var $: any;
@Component({
  selector: 'app-list-chat',
  templateUrl: './list-chat.component.html',
  styleUrls: ['./list-chat.component.scss']
})
export class ListChatComponent implements OnInit, OnDestroy {

  unsubscribe$ = new Subject();
  user$;
  businessId;
  // tslint:disable-next-line:variable-name
  firebase_token: string;
  @Output('conversation') conversation = new EventEmitter();
  subscriptions: Subscription[] = [];
  public limit = 10;
  public offset = 0;
  public list: any = [];
  public clientChats;
  public itemsRef: AngularFireList<any>;
  public itemsRefRoom: AngularFireList<any>;
  public onlines: any = {};
  // tslint:disable-next-line:variable-name
  public conversation_unread = 0;
  public unreads: any = {};
  public titleUnread: string;
  listChat : Subscription;
  // tslint:disable-next-line:variable-name
  public selected_conversation: any;
  // tslint:disable-next-line:variable-name
  public selected_conversation_key: string;
  // tslint:disable-next-line:variable-name
  public selected_friend: any;
  // tslint:disable-next-line:variable-name
  public is_loading = false;
  public endAt: number = Number(new Date());
  public friends: any = {};
  // tslint:disable-next-line:variable-name
  public number_unread = 0;
  public listUnread: any = [];
  // tslint:disable-next-line:variable-name

  key_chat;
  // tslint:disable-next-line:variable-name
  select_first = true;
  test = '';
  // tslint:disable-next-line:variable-name
  tab_selecting: number;
  @Output() emitData = new EventEmitter();
  constructor(
    private  businessInfoService: BusinessInfoService,
    private accountService: AccountInfoService,
    private db: AngularFireDatabase,
    private chatService: ChatService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private businessResolver: BusinessResolver,
    private businessCode: BusinessCodeService,
  ) {

  }
  content = '';
  time = '';
  clientId: number;
  name = '';
  keys;
  senderDb
  conversations;
  unsubscribe$Chat: Subscription
  @Output() clearConversations = new EventEmitter();
  async  ngOnInit() {

    const firebaseToken =  await this.businessCode.getFirebaseToken().toPromise();
    await this.authService.signIn(firebaseToken.data);
    console.log(123)
  }
  select(event) {
    this.tab_selecting = event;
  }
  async loadContent(event: GlnInfoDto) {
    console.log(event);

    if (this.tab_selecting === 1) {
      this.tab_selecting = 0;
    }
    this.select_first = true;
    this.list = [];
    this.titleUnread = 'Chưa đọc';

    this.businessId = event.idPage;

    const option = new OptionDto();
    this.loadData(option ,  this.businessId );
    // this.getStatusRead();
    await this.chatService.updateConversationSource$.pipe(takeUntil(this.unsubscribe$)).subscribe();
  }

  loadData(options: OptionDto, businessId) {
    this.is_loading = true;

    this.itemsRef = this.db.list(`/chat-conversations-v2/page|${businessId}`, ref => ref.orderByChild('lastMessage/timestamp')
      .limitToLast(options.limit).endAt(options.endAt));
    if (this.listChat) {
      this.listChat.unsubscribe();
    }

    this.listChat =  this.itemsRef.snapshotChanges(['child_added', 'child_changed']).pipe(
      map(changes => {
        return changes.map(c => {
          return {key: c.key, value: c.payload.val()};
        });
      }) )
      .subscribe( msgs => {
        if (msgs.length > 0) {
          console.log('===> msgs ' , msgs);
          this.is_loading = false;
          this.loadRoomToGetIdUser( msgs.map(z => z.key), msgs.map(z => z.value) );
        } else {
          this.loadRoomToGetIdUser();
        }
      });

  }

  loadRoomToGetIdUser(keys?: string[], lastConversation?) {
    if (keys && lastConversation) {
      this.keys = keys;
      this.conversations = lastConversation;
      const arr = [];
      const listConversation = [];
      const lstClient = []
      for (const key of keys) {
        console.log(key)
        arr.push( this.db.list<Room>(`/chat-rooms-v2/${key}`)
          .snapshotChanges(['child_added']));
      }
      combineLatest(arr).subscribe(async object => {

        for (const val of object) {
          // @ts-ignore
          const room = mapRoom( val.map(z => z.payload.val()));
          const client = room.members[ Object.keys(room.members).filter(z => z !== `page|${this.businessId}`)[0] ];
          lstClient.push(client);
          // @ts-ignore
          // tslint:disable-next-line:no-shadowed-variable
          this.db.list(`/chat-senders-v2/${client.id}`).snapshotChanges().pipe(map(changes => {
            const value = {};
            return changes.map(z =>  {
              value[z.key] = z.payload.val();
              return value
            });
          }), take(1)).subscribe(z => {
            listConversation.push(z[0]);
            this.clientChats  = listConversation.map((val, index) => {
              // @ts-ignore
              return {val , lastConversation: lastConversation[index] , key : keys[index], source_id : lstClient[index].source_id};
            });
            console.log('this.clientChats', this.clientChats)

          })
        }

        // client Chats
        this.selectTabUnread();
      });
    } else {
      this.clientChats = [];
      this.clearConversations.emit([]);
    }
  }


  removeUnread(key) {
    const itemRef = this.db.list(`/chat-conversations-v2/page|${this.businessId}`).update(key, { unread_count: 0});
    this.loadRoomToGetIdUser(this.keys, this.conversations);

  }

  loadDetailChat(client) {
    if (this.unsubscribe$Chat) {
      this.unsubscribe$Chat.unsubscribe();
    }
    // tslint:disable-next-line:max-line-length
    this.unsubscribe$Chat =   this.db.list(`/chat-details-v2/${client.key}`, ref => ref.orderByChild('lastMessage/timestamp').limitToLast(100).endAt(1000))
      .snapshotChanges(['child_added', 'child_removed', ]).pipe(map(changes => {
        return changes.map((z) => {
          const value = z.payload.val();
          // @ts-ignore
          value.key = z.key;
          return value;
        });

      }), takeUntil(this.unsubscribe$)).subscribe(z => {
        console.log("client===> " , client)
        this.emitData.emit({conversations: z, client});
      });
  }
  selectChangeTab() {
    if (this.tab_selecting === 1) {
      this.getFriendsChat(this.list);
    }
    this.select_first = true;
    this.selected_conversation = null;
    this.selected_conversation_key = null;
    this.selected_friend = null;
    this.chatService.selectChangetab(false);
  }

  selectTabUnread() {
    // this.selectChangeTab();
    if (this.clientChats) {
      this.listUnread = this.clientChats.filter(z => z.lastConversation.unread_count > 0);
    }
  }

  async getFriendsChat(msgs) {
    // tslint:disable-next-line:variable-name
    const list_actor_id = [];
    msgs.forEach(msg => {
      const actors = msg.key.split('|');
      // tslint:disable-next-line:variable-name
      let actor_id = actors[0] !== 'i-' + this.businessId ? actors[0] : actors[1];
      actor_id = actor_id.replace('i-', '');
      list_actor_id.push(actor_id);
    });
    const p = new Promise(resolve => {
      if (list_actor_id.length) {
        this.accountService.getInfoUserChat(list_actor_id).subscribe(
          async res1 => {
            if (res1.code === 1) {
              const data = res1.data;
              await list_actor_id.map(val => {
                data.map(i => {
                  // tslint:disable-next-line:radix
                  if (i.id === parseInt(val)) {
                    this.friends['i-' + val] = {
                      avatar: i.avatar ? i.avatar : '',
                      name: i && i.name ? i.name : ''
                    };
                  }
                });
              });
              resolve(res1.data[0]);
            }
          }
        );
      }
    });
    p.then(res => {
      if (this.select_first) {
        this.selectConversation(this.list[0].key, res);
        this.select_first = false;
      }
    });
  }

  standMessages(msgs, unread = false) {
    msgs.forEach(msg => {
      const actors = msg.key.split('|');
      // tslint:disable-next-line:variable-name
      let actor_id = actors[0] !== 'i-' + this.businessId ? actors[0] : actors[1];
      actor_id = actor_id.replace('i-', '');
      const item = this.parseLastMessage(msg.key, msg.lastMessage);
      if (item === undefined) {
        return;
      }
      if (unread) {
        this.listUnread.push(item);
      } else {
        this.list.push(item);
        this.uniqueFriend(this.list);
      }
    });
    this.listUnread = _.sortBy(this.listUnread, (obj) => obj.timestamp);
    this.listUnread = _.reverse(this.listUnread);
  }


  uniqueFriend(list) {
    const listFriendId = [];
    this.list = list.filter((value) => {
      if (!listFriendId.includes(value.friend_id)) {
        listFriendId.push(value.friend_id);
        return value;
      }
    });
  }

  playSound() {
    const audio = new Audio();
    audio.src = '../../../../assets/sound.mp3';
    audio.load();
    audio.play();
  }

  checkOnline(msgs) {
    msgs.forEach(msg => {
      const actors = msg.key.split('|');
      // tslint:disable-next-line:variable-name
      const actor_id = actors[0] !== 'i-' + this.businessId ? actors[0] : actors[1];
      this.subscriptions.push(
        this.db.object(`/users/${actor_id}`).valueChanges().subscribe((user: models.User) => {
          if (user.isOnline) {
            this.onlines[actor_id] = true;
          }
        }));
    });
  }

  parseLastMessage(key, lastMessage) {
    if (lastMessage === undefined) {
      return;
    }
    const keys = Object.keys(lastMessage.message);
    let msg;

    if (keys.indexOf('post') > -1) {
      msg = (lastMessage.sentBy !== 'i-' + this.businessId) ? 'Bạn vừa nhận được một bài viết' : 'Bạn vừa gửi một bài viết';
    }

    if (keys.indexOf('shop_product') > -1 || keys.indexOf('product') > -1 || keys.indexOf('icheck_product') > -1) {
      msg = (lastMessage.sentBy !== 'i-' + this.businessId) ? 'Bạn vừa nhận được một sản phẩm' : 'Bạn vừa gửi một sản phẩm';
    }

    if (keys.indexOf('sticker') > -1) {
      msg = (lastMessage.sentBy !== 'i-' + this.businessId) ? 'Bạn vừa nhận được bày tỏ một cảm xúc' : 'Bạn vừa bày tỏ một cảm xúc';
    }

    if (keys.indexOf('link') > -1) {
      msg = (lastMessage.sentBy !== 'i-' + this.businessId) ? 'Bạn vừa nhận được một đường dẫn' : 'Bạn vừa gửi một đường dẫn';
    }

    if (keys.indexOf('image') > -1) {
      msg = (lastMessage.sentBy !== 'i-' + this.businessId) ? 'Bạn vừa nhận được một hình ảnh' : 'Bạn vừa gửi một hình ảnh';
    }

    if (keys.indexOf('content') > -1) {
      msg = lastMessage.message.content.length > 20 ? lastMessage.message.content.substring(0, 20) + '...' : lastMessage.message.content;
    }

    const actors = key.split('|');
    // tslint:disable-next-line:variable-name
    const actor_id = actors[0] !== 'i-' + this.businessId ? actors[0] : actors[1];

    return {
      sentBy: lastMessage.sentBy,
      timestamp: lastMessage.timestamp,
      type: keys[0],
      message: msg,
      key,
      friend_id: actor_id
    };
  }

  selectConversation(key, friend) {
    this.key_chat = key;
    this.chatService.selectChangetab(true);
    this.selected_conversation = _.find(this.list, {key});
    this.selected_conversation_key = key;
    this.selected_friend = friend;
    this.chatService.selectConversation({key, friend});

    if (this.unreads[key] && this.unreads[key]) {
      // tslint:disable-next-line:variable-name
      const num_unread = this.number_unread > 1 ? this.number_unread - 1 : 0;
      this.businessResolver.setUnread(num_unread);
    }
  }

  @HostListener('scroll', ['$event'])
  onScroll(event: any) {
    if (Math.ceil(event.target.offsetHeight) + Math.ceil(event.target.scrollTop) >= event.target.scrollHeight) {
      // this.loadData({limit: 10, endAt: this.endAt, history: true});
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();


    //  this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
